import ImageBanner from '../components/ImageBanner';
import BannerTitle from '../components/BannerTitle';
import PressList from '../container/PressList';
import Head from 'next/head';

const Press = () => (
  <div>
    <Head>
      <title>Shaking Crab | Press</title>
    </Head>
    <ImageBanner image='https://tools.shakingcrab.com/storage/images/9a/d872dc10aec20dcb7de22de928a2c6.jpg'>
      <BannerTitle title='Press' />
    </ImageBanner>
    <PressList />
  </div>
);

export default Press;
